"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionEnum = void 0;
var SubscriptionEnum;
(function (SubscriptionEnum) {
    SubscriptionEnum["All"] = "all";
    SubscriptionEnum["Premium"] = "premium";
    SubscriptionEnum["PremiumPlus"] = "premiumPlus";
    SubscriptionEnum["PastDue"] = "pastDue";
    SubscriptionEnum["Free"] = "free";
})(SubscriptionEnum = exports.SubscriptionEnum || (exports.SubscriptionEnum = {}));
//# sourceMappingURL=subscription-enum.js.map